import React from 'react';

const MacroCard = ({ macros, targets }) => {
  // macros: { calories, exercise, carbs, protein, fat }
  // targets: { calories, carbs, protein, fat }
  const foodCalories = macros.calories || 0;
  const exerciseCalories = macros.exercise || 0;
  const remainingCalories = (targets?.calories || 0) - foodCalories + exerciseCalories;
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Calories Card */}
        <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-4 border border-blue-100">
          <div className="flex items-center justify-center mb-3">
            <span className="text-2xl mr-2" role="img" aria-label="flame">🔥</span>
            <span className="font-semibold text-lg text-gray-800">Calories</span>
          </div>
          <div className="grid grid-cols-3 gap-2 text-center">
            <div>
              <div className="font-bold text-lg text-blue-600">{foodCalories}</div>
              <div className="text-xs text-gray-600">Food</div>
            </div>
            <div>
              <div className="font-bold text-lg text-green-600">{exerciseCalories}</div>
              <div className="text-xs text-gray-600">Exercise</div>
            </div>
            <div>
              <div className="font-bold text-lg text-orange-600">{remainingCalories}</div>
              <div className="text-xs text-gray-600">Remaining</div>
            </div>
          </div>
        </div>

        {/* Macros Card */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
          <div className="flex items-center justify-center mb-3">
            <span className="text-2xl mr-2" role="img" aria-label="pie">🥧</span>
            <span className="font-semibold text-lg text-gray-800">Macros</span>
          </div>
          <div className="grid grid-cols-3 gap-2 text-center">
            <div>
              <div className="font-bold text-lg text-cyan-600">
                {macros.carbs || 0}
                <span className="text-sm text-gray-500">/{targets?.carbs || 0}</span>
              </div>
              <div className="text-xs text-gray-600">Carbs (g)</div>
            </div>
            <div>
              <div className="font-bold text-lg text-purple-600">
                {macros.protein || 0}
                <span className="text-sm text-gray-500">/{targets?.protein || 0}</span>
              </div>
              <div className="text-xs text-gray-600">Protein (g)</div>
            </div>
            <div>
              <div className="font-bold text-lg text-yellow-600">
                {macros.fat || 0}
                <span className="text-sm text-gray-500">/{targets?.fat || 0}</span>
              </div>
              <div className="text-xs text-gray-600">Fat (g)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MacroCard;